import { Component } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { Platform } from '@ionic/angular';

declare let ga: any;

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html'
})
export class AppComponent {

  private trackEvents = false;

  constructor(
    private platform: Platform,
    public router: Router
  ) {
    this.initializeApp();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (this.trackEvents) {
          try {
            if (ga) {
              const tracker = ga.getAll()[0];
              if (tracker) {
                tracker.send('pageview', event.urlAfterRedirects)
              }
            }
          } catch (error) { }
        } else {
          this.trackEvents = true
        }
      }
    });
  }

  initializeApp() {
    this.platform.ready().then(() => {

    });
  }

  get isIE(): boolean {
    const match = navigator.userAgent.search(/(?:MSIE|Trident\/.*; rv:)/);
    let isIE = false;

    if (match !== -1) {
      isIE = true;
    }

    return isIE;
  }
}
